<div class="container-fluid">
    <app-pagetitle title="Add Diagnostic Tests" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>
</div>
<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <button type="button" class="btn btn-success" (click)="gotoassigntest()">
                    <i class=" ri-menu-2-fill align-middle me-2"></i>Assign Diagnostic Test
                </button>
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Diagnostic Test Date: <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="date" [min]="now" class="form-control" formControlName="diagnostic_date"
                                     />
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Diagnostic Test Name: <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="text" class="form-control" formControlName="diagnostic_name"
                                    placeholder="Enter Test Name" />
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="form-group">
                                <label>Diagnostic Test Amount: <span style="color:red">&nbsp;&nbsp;*</span></label>
                                <input type="number" class="form-control" formControlName="diagnostic_amount"
                                    placeholder="only Numbers" />
                            </div>
                        </div>
                       
                        
                    </div>
                </form>
                <div class="form-group mb-0" style="text-align: right;">
                    <br>
                    <button type="submit" class="btn btn-primary me-1" (click)="typeSubmit()"> Submit </button>
                    <button type="reset" (click)="reset()" class="btn btn-secondary"> Reset </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">Diagnostic Tests Data</h4>
                <div class="table-responsive">
                    <table class="table table-bordered table-striped mb-0 table-striped">
                        <thead class="table-dark">
                            <tr>
                                <th>S.no</th>
                                <th>Diagnostic Test Date</th>
                                <th>Diagnostic Test Name</th>
                                <th>Diagnostic Test Amount</th>
                                <th>Action </th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let i of data;let y =index">
                                <td scope="row">{{y+1}}</td>
                                <td>{{i.diagnostic_date}}</td>
                                <td>{{i.diagnostic_name}}</td>
                                <td>{{i.diagnostic_amount}}</td>
                               
                            
                                <td>
                                    <div style="display: flex;">

                                        <i style="font-size: 20px;border-radius:5px;background-color: rgb(31, 115, 31);color: white;padding: 2%;"
                                            class="ri-edit-fill" title="Edit"
                                            (click)="centerModal(centerDataModal,i)"></i>&nbsp;&nbsp;
                                        <i style="font-size: 20px;border-radius:5px;background-color: rgb(83, 12, 12);color: white;padding: 2%;"
                                            class="ri-delete-bin-2-line" title="Delete" (click)="Delete(i)"></i>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #centerDataModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">Edit Diagnostic Test Details </h5>
        <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')" aria-hidden="true"></button>
    </div>
    <div class="modal-body">
        <form (ngSubmit)="edit()" [formGroup]="editForm">
            <div class="row">
               
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Diagnostic Test Date: <span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="date" [min]="now" class="form-control" formControlName="diagnostic_date"
                             />
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Diagnostic Test Name: <span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="text" class="form-control" formControlName="diagnostic_name"
                            placeholder="Enter Test Name" />
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="form-group">
                        <label>Diagnostic Test Amount: <span style="color:red">&nbsp;&nbsp;*</span></label>
                        <input type="number" class="form-control" formControlName="diagnostic_amount"
                            placeholder="only Numbers" />
                    </div>
                </div>
               
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary me-1"> Save changes </button>
                    <button type="reset" class="btn btn-secondary"> Reset</button>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<!-- <app-rooms></app-rooms> -->
